import { createFileRoute } from "@tanstack/react-router"
import { requirePermission } from "@/lib/require-permission"
import { NOTIFICATION_RULES_PERMISSION } from "./-lib/permission"

export const Route = createFileRoute(
  "/_layout/settings/_panel/workspace/notification-rules",
)({
  staticData: {
    breadcrumb: [
      {
        label: "Workspace - Notification rules",
        href: "/settings/workspace/notification-rules",
      },
    ],
  },
  beforeLoad: ({ context: { queryClient } }) =>
    requirePermission(
      queryClient,
      NOTIFICATION_RULES_PERMISSION,
      "/settings/workspace/general",
    ),
})
